import React from "react";
import Table from "../../common-components/table/table";
import { getTableData } from "./helpers";
import { IGetInsurancePremiumPortfolioData } from "../../../../../services/ClientsDashboardServices.dto";

const InsurancePremiumPortfolioTable = ({ data }: { data: IGetInsurancePremiumPortfolioData }) => {
  const { headRow, bodyRows } = getTableData(data);

  return <Table headRow={headRow} bodyRows={bodyRows} className="small sticky-header" />;
};

export default InsurancePremiumPortfolioTable;
